import { useMutation } from '@apollo/client';
import { Store } from '@website/Store';
import { ClaimGuestDocument } from '@website/types/graphqlOperations';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import LoadingPage from '../utilities/LoadingPage';

export default function ClaimGuest() {
  const { state } = useContext(Store);

  const { query, push, isReady } = useRouter();
  const { accessCode, spaceID } = query;

  const [claimGuest] = useMutation(ClaimGuestDocument, {});

  useEffect(() => {
    const onClickClaimGuest = async () => {
      try {
        await claimGuest({
          variables: {
            input: {
              accessCode: accessCode as string,
              spaceID: spaceID as string,
              userID: state.user.id,
            },
          },
        });

        // redirect to users dashboard
        push(`/me/${state.user.id}`);
      } catch (e) {
        if (e.networkError) {
          alert(
            'Internet connection lost - please retry when you are connected.',
          );
        } else {
          alert(e);
        }
      }
    };

    if (accessCode && spaceID) {
      onClickClaimGuest();
    }
  }, [accessCode, claimGuest, push, spaceID, state.user.id]);

  if (!isReady) {
    return <LoadingPage />;
  }

  if (!accessCode || !spaceID) {
    return (
      <>
        <h1>Sorry!</h1>
        <p>
          Your link was incorrect - please ask your friend to send it again.
        </p>
      </>
    );
  }

  return (
    <>
      <Container>
        <LoadingPage />
      </Container>
    </>
  );
}
